import { styled, ToggleButtonGroup } from '@mui/material';

export const CustomToggleButtonGroup = styled(ToggleButtonGroup)(
    ({ theme }) => ({
        height: '50px',
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        '& .MuiToggleButton-root': {
            border: 'none',
            '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
            },
        },
    })
);
